import BillingsPlanEntryRelatedCargoTaxiResponse, {
  BillingsPlanEntryRelatedCargoTaxiResponseData,
  BillingsPlanEntryRelatedCargoTaxiResponseDataBillingStatus,
  BillingsPlanEntryRelatedCargoTaxiResponseDataContract,
  BillingsPlanEntryRelatedCargoTaxiResponseDataContractBillingModel,
} from "../../../../../api/raily/billings/plan-entry/related/cargo-taxi/billings-plan-entry-related-cargo-taxi.response";
import BillingModel from "../../../../../types/billing-model";
import BillingStatus from "../../../../../types/billing-status";
import BillingsPlanEntryRelatedCargoTaxi, {
  BillingsPlanEntryRelatedCargoTaxiItem,
  BillingsPlanEntryRelatedCargoTaxiItemContractDetails,
} from "./billings-plan-entry-related-cargo-taxi";

const createDataItemStatus = (
  status: BillingsPlanEntryRelatedCargoTaxiResponseDataBillingStatus,
): BillingStatus => {
  switch (status) {
    case BillingsPlanEntryRelatedCargoTaxiResponseDataBillingStatus.ACCEPTED:
      return BillingStatus.ACCEPTED;
    case BillingsPlanEntryRelatedCargoTaxiResponseDataBillingStatus.CREATED:
      return BillingStatus.CREATED;
    case BillingsPlanEntryRelatedCargoTaxiResponseDataBillingStatus.REJECTED:
      return BillingStatus.REJECTED;
    case BillingsPlanEntryRelatedCargoTaxiResponseDataBillingStatus.REOPENED:
      return BillingStatus.REOPENED;
    case BillingsPlanEntryRelatedCargoTaxiResponseDataBillingStatus.REOPEN_REQUEST:
      return BillingStatus.REOPEN_REQUEST;
  }
};

const createDataItemBillingModel = (
  billingModel: BillingsPlanEntryRelatedCargoTaxiResponseDataContractBillingModel,
): BillingModel => {
  switch (billingModel) {
    case BillingsPlanEntryRelatedCargoTaxiResponseDataContractBillingModel.ABA:
      return BillingModel.ABA;
    case BillingsPlanEntryRelatedCargoTaxiResponseDataContractBillingModel.SABS:
      return BillingModel.SABS;
    case BillingsPlanEntryRelatedCargoTaxiResponseDataContractBillingModel.AB:
      return BillingModel.AB;
    case BillingsPlanEntryRelatedCargoTaxiResponseDataContractBillingModel.OTHER:
      return BillingModel.OTHER;
  }
};

const createDataItemContractDetails = (
  contractDetails: BillingsPlanEntryRelatedCargoTaxiResponseDataContract,
): BillingsPlanEntryRelatedCargoTaxiItemContractDetails => {
  return {
    companyName: contractDetails.cargoCompany.displayName,
    model: createDataItemBillingModel(contractDetails.model),
    distanceRate: contractDetails.distanceRate,
  };
};

const createDataItem = (
  data: BillingsPlanEntryRelatedCargoTaxiResponseData,
): BillingsPlanEntryRelatedCargoTaxiItem => {
  return {
    billingUuid: data.id,
    cargoOrderUuid: data.cargoOrder?.id!,
    contractDetails: createDataItemContractDetails(data.contract),
    amountForDistance: data.amountForDistance,
    amountForChargeHaltings: data.amountForChargeHaltings,
    amountForChargeHighways: data.amountForChargeHighways,
    distance: data.distance,
    internalOrderId: data.cargoOrder?.humanId!,
    contractCorrectionPercentage: data.contractCorrectionPercentage,
    allContributionsAmount: data.allContributionsAmount,
    sumOfDiscounts: data.sumOfDiscounts,
    isDraft: data.draft,
    date: data.date,
    status: createDataItemStatus(data.status),
  };
};

const createData = (
  responseData: BillingsPlanEntryRelatedCargoTaxiResponseData[],
): BillingsPlanEntryRelatedCargoTaxiItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: BillingsPlanEntryRelatedCargoTaxiResponse,
): BillingsPlanEntryRelatedCargoTaxi => {
  return {
    data: createData(response.data),
  };
};

const billingsPlanEntryRelatedCargoTaxiFactory = {
  create,
};

export default billingsPlanEntryRelatedCargoTaxiFactory;
